module.exports = __webpack_public_path__ + "static/img/69特惠.640e56f.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/69特惠.png
// module id = 1194
// module chunks = 18